import styled from "styled-components"

export const InputField = styled.input`
  width: 5.6rem !important;
  height: 6.4rem !important;
  border: 2px solid #00000033 !important;
  border-radius: 0.8rem !important;
  padding: 0.5rem !important;
  font-size: 3.2rem !important;
  font-weight: 400 !important;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #000000 !important;

  &:focus {
    outline: none;
    border-color: #000 !important;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }

  &:disabled {
    opacity: 0.5 !important;
  }

  ${({ error }) => error && `border-color: #b6471f !important; color: #b6471f !important;`}
`
